module.exports = __webpack_public_path__ + "img/35897-050.348b2bc1.jpg";